import { Component, Input } from "@angular/core";
import * as Moment from "moment";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-component-detail",
	templateUrl: "./component-detail.component.html",
	styleUrls: ["./component-detail.component.scss"]
})
export class ComponentDetailComponent {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	shaft: AssemblyConfig.Shaft | AssemblyConfig.MotorShaft;

	public selectedraw: APIResults.RawSinglesResult | APIResults.RawPairsResult;

	constructor(private api: ApiService) { }

	rawSelected(raw: APIResults.RawSinglesResult | APIResults.RawPairsResult) {
		if (this.selectedraw !== raw) {
			this.selectedraw = raw;
		}
	}

	DownloadRaw(format: string, extension: string) {
		// this.api.ExportStates(this.asset.asset_name + "_" + this.selectedOperation.start_time.format("YYYY-MM-DD HHmmss") + "_STATES.csv", this.asset.asset_id, this.selectedOperation.operation_id);
		const ts = Moment(this.selectedraw.ts);
		let rawid;
		if ("rawid" in this.selectedraw) {
			rawid = this.selectedraw.rawid;
		} else {
			rawid = this.selectedraw.viberawid;
		}
		this.api.ExportRaw(this.asset.asset_name + "_" + this.component.id + "_" + ts.format("YYYY-MM-DD HHmmss") + "." + extension, this.asset.asset_id, rawid, format);
	}

}
